module.exports = __webpack_public_path__ + "static/media/Boye.9404b382.m4a";